var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.699,
    height: 15.7,
    viewBox: "0 0 9.699 15.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Back_-_Header",
    "data-name": "Back - Header",
    d: "M2.183,9.813,9.1,2.9a.854.854,0,0,1,1.208,0l.807.807a.854.854,0,0,1,0,1.206l-5.48,5.506,5.48,5.506a.854.854,0,0,1,0,1.206l-.807.807a.854.854,0,0,1-1.208,0L2.183,11.021A.854.854,0,0,1,2.183,9.813Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 11.678, 18.149)",
    fill: "#00838d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackHeader);
export default __webpack_public_path__ + "static/media/Back - Header.6a080d82e5f625f6df3d31f69b52236f.svg";
export { ForwardRef as ReactComponent };